
import styled from "@emotion/styled";
import { GetPageQuery } from "apollo";
import AccordionFaq from "components/PazClub/AccordionFaq";
import ContainerWrapper from "pazChargeComponents/general/ContainerWrapper";
import { TitleWithLine, extractProperty } from "ui";


type Props = {
    data: GetPageQuery
}
const StyledWrapper = styled.div`
    padding-top: 60px;
    padding-bottom: 60px;
  ${(props) => props.theme.breakpoints.up("md")} {
    padding-top: 80px;
    padding-bottom: 80px;
  }
`
function QuestionListBlockCharge({ data }: Props) {
    const blockTitle = extractProperty(data, "blockTitle")
    const questions: any[] = extractProperty(data, "questions")
    return (
        <ContainerWrapper>
            <StyledWrapper>
                <TitleWithLine
                    title={blockTitle}
                    titleFontSize={34}
                    desktopFontWeight={500}
                    desktopLineHeight="36px"
                    mobileTitleFontSize={24}
                    titleColor="black"
                    component={"h2"}
                    noMobileMargin
                    />
                <AccordionFaq
                    accordion={questions}
                    titleProp="title"
                    contentProp="answer"
                    arrowIconSize={24}
                    titleOverrideStyle={{ desktopFontSize: 18, mobileFontSize: 16, largeDesktopFontSize: 18, mobileLineHeight: "18px", desktopLineHeight: "20px", largeDesktopLineHeight: "20px" }}
                    contenrOverrideStyle={{ desktopFontSize: 18, mobileFontSize: 16, largeDesktopFontSize: 18, mobileLineHeight: "18px", desktopLineHeight: "20px", largeDesktopLineHeight: "20px" }}
                >
                </AccordionFaq>
            </StyledWrapper>
        </ContainerWrapper>
    );
}

export default QuestionListBlockCharge;
